import axios from 'axios';

const authToken =
  localStorage.getItem('authToken') || sessionStorage.getItem('authToken');
const headers = authToken ? { Authorization: `Token ${authToken}` } : {};

export const ExamcompassClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers,
});
